import { Injectable, InjectionToken } from '@angular/core';
import { Store } from '@ngrx/store';
import { GoogleAccountActions } from '../..';

export interface GoogleAccountService {
  disconnect(disconnectUrl: string): void;
}

export const GOOGLE_ACCOUNT_SERVICE = new InjectionToken<GoogleAccountService>('GOOGLE_ACCOUNT_SERVICE');

@Injectable()
export class GoogleAccountFacade implements GoogleAccountService {
  constructor(private _store: Store) {}

  disconnect(disconnectUrl: string): void {
    this._store.dispatch(GoogleAccountActions.disconnectGoogleAccount({ disconnectUrl }));
  }
}
